import { type ReactNode } from 'react';
import { Avatar } from '@/components/ui/avatar';
import { CategoryBadge } from '@/components/ui/category-badge';
import type { Creator } from '@/types';
import { formatFollowers } from '@/utils/formatters';
import { creatorPhotoUrl } from '@/utils/creator-helpers';

function CardBody({ creator }: { creator: Creator }): ReactNode {
  return (
    <div className="flex items-center gap-sm">
      <Avatar
        src={creatorPhotoUrl(creator)}
        name={creator.ig_username}
        size="sm"
      />
      <div className="min-w-0 flex-1">
        <p className="truncate text-xs font-medium text-text-primary">
          @{creator.ig_username}
        </p>
        <div className="mt-0.5 flex items-center gap-xs">
          <span className="text-[10px] tabular-nums text-text-tertiary">
            {formatFollowers(creator.followers)}
          </span>
          <CategoryBadge
            type={creator.creator_type}
            category={creator.category}
          />
        </div>
      </div>
    </div>
  );
}

export function KanbanCardOverlay({
  creator,
}: {
  creator: Creator;
}): ReactNode {
  return (
    <div className="w-[224px] cursor-grabbing scale-105 rounded-md border border-white/[0.08] bg-surface-elevated p-sm shadow-lg">
      <CardBody creator={creator} />
    </div>
  );
}
